'use strict';

angular.module('portal.inspections')
    .controller('PortalInspections', ['$scope', 'IPVisits', 'FBResponses', '$rootScope', 'Resource', 'Cache', '$q', 'IPCheckoutLogs', '$uibModal', 'IPInspections', '$filter', 'TGTriggers', '$window',
        function ($scope, IPVisits, FBResponses, $rootScope, Resource, Cache, $q, IPCheckoutLogs, $uibModal, IPInspections, $filter, TGTriggers, $window) {
            $scope.loading = true;
            $scope.submitting = false;
            $scope.months = Resource.months();
            $scope.listParams = {
                currentPage: 0,
                numPerPage: 10
            }

            IPVisits.getYears().then(function (years) {
                $scope.years = years;
            });

            $scope.inspectionColumns = [
                {
                    label: $rootScope.enterprise.serviceLabels['SERVICE'] + '/' + $rootScope.enterprise.vehicleLabels['VEHICLE'],
                    field: 'name',
                    link: {
                        state: 'portal.inspection',
                        params: [
                            {
                                name: 'id',
                                field: 'id'
                            },
                            {
                                name: 'inspection',
                                field: ''
                            }
                        ],
                        disabled: 'inspectionNotCheckedOut'
                    },
                    document: {
                        id: 'checklist.document.id',
                        code: 'checklist.document.code',
                        url: $rootScope.portalURL + 'controller.cfm?method=publicPortalService.openDocument'
                    },
                    info: [
                        {
                            label: 'Unit Number',
                            field: 'vehicle.unit_number'
                        },
                        {
                            label: 'Call Sign',
                            field: 'vehicle.call_sign'
                        }
                    ],
                    icon: {
                        field: 'indicator.field', // values include not opened, complete, and incomplete (invalid, required fields not filled out)
                        title: 'indicator.title',
                        show: 'indicator.show'
                    }
                },
                {
                    label: 'Number',
                    field: 'number'
                },
                {
                    label: 'Inspector',
                    field: 'inspector_show'
                },
                {
                    label: 'Status',
                    field: 'status.name'
                },
                {
                    label: 'Failures',
                    field: 'checklist.deficiencies_fail_show',
                    type: 'deficiency_total'
                }
            ];

            $scope.canDownload = function (visit) {
                var download = false;

                visit.inspections.forEach(function (inspection) {
                    if ((inspection.inspector_id == $rootScope.userAccount.inspector_id || inspection.inspector_id == null) &&
                        inspection.checklist != null && inspection.checklist.template != null &&
                        (inspection.status == null || inspection.status.allow_checkout)) {
                        download = true;
                    }
                });

                return download;
            }

            $scope.getVisits = function (month, year) {
                $scope.loading = true;

                if ($rootScope.offline) {
                    Cache.getAll('visit').then(function (visits) {
                        if (month == $scope.month && year == $scope.year) {
                            $scope.visits = $filter('month')($filter('year')(visits, year, 'inspection_date'), month, 'inspection_date');

                            // just to get indicators to load properly
                            if ($scope.visits != null) {
                                $scope.visits.forEach(function (visit) {
                                    if (visit != null && visit.inspections != null) {
                                        visit.inspections.forEach(function (visitInspection) {
                                            if (visitInspection != null) {
                                                Cache.get('inspection', visitInspection.id).then(function (inspection) {
                                                    if (inspection != null && inspection.checklist != null) {
                                                        visitInspection.checklist.deficiencies_fail_show = inspection.checklist.deficiencies_fail;
                                                        visitInspection.inspector_show = inspection.inspector == null ? null : inspection.inspector.name;
                                                        visitInspection.indicator = inspection.checklist.isFormValid == null ? { field: 'empty', title: 'Not Started' } : (inspection.checklist.isFormValid && $scope.deficenciesComplete(inspection.checklist)) ? { field: 'full', title: 'Complete' } : { field: 'half', title: 'Incomplete' };
                                                        visitInspection.inspector_show ? visitInspection.indicator.show = true : visitInspection.indicator.show = false;
                                                        if (visitInspection.indicator.show) visitInspection.checklist.document = null; // just to get rid of icon
                                                    }
                                                });
                                            }
                                        });
                                    }
                                });
                            }

                            $scope.loading = false;
                        }
                    });
                }
                else {
                    IPVisits.get(true, month, year).then(function (visits) {
                        if (month == $scope.month && year == $scope.year) {
                            $scope.visits = visits;

                            // need to ensure checked out visits are cached
                            $scope.visits.forEach(function (visit) {
                                visit.loading = false;
                                visit.resetting = false;
                                visit.downloading = false;
                                visit.submitting = false;

                                if (visit.checked_out) {
                                    visit.loading = true;

                                    $scope.cacheVisit(visit, false).then(function () {
                                        //if we are downloading an inspection pre cache the form edit pages.
                                        caches.keys().then(function (cachelist) {
                                            cachelist.forEach(function (worker) {
                                                //if we are downloading an inspection pre cache the form edit pages.
                                                caches.open(worker).then(function (cache) {
                                                    var url = paths.app + 'inspection/' + visit.id;
                                                    fetch(url).then(function (response) {
                                                        cache.put(url, response);
                                                    })
                                                    cache.add(paths.app + 'inspections/components/inspection/inspection.html');
                                                });
                                            });
                                        });
                                        visit.loading = false;
                                    });
                                }
                            });

                            $scope.loading = false;
                        }
                    });
                }
            }

            $scope.$watch('offline', function (newStatus, oldStatus) {
                if (newStatus != oldStatus) {
                    $scope.getVisits($scope.month, $scope.year);
                }
            });

            Cache.getState('list').then(function (state) {
                if (state != null) {
                    $scope.sortBy = state.sortBy;
                    $scope.reverse = state.reverse;
                    $scope.search = state.search;
                    $scope.listParams.currentPage = state.currentPage;
                    $scope.listParams.numPerPage = state.numPerPage;
                    $scope.status = state.status;
                    $scope.month = state.month;
                    $scope.year = state.year;
                }
                else {
                    $scope.month = new Date().getMonth();
                    $scope.year = new Date().getFullYear();
                    $scope.listParams.currentPage = 0;
                    $scope.listParams.numPerPage = 10;
                }

                $scope.getVisits($scope.month, $scope.year);
            });

            $scope.cacheList = function () {
                var state = {
                    sortBy: $scope.sortBy,
                    reverse: $scope.reverse,
                    search: $scope.search,
                    currentPage: $scope.listParams.currentPage,
                    numPerPage: $scope.listParams.numPerPage,
                    status: $scope.status,
                    month: $scope.month,
                    year: $scope.year
                }

                Cache.setState('list', state);
            }

            $scope.$watch('search + status + month + year', function (old, newie) {
                if (old != newie) {
                    $scope.listParams.currentPage = 0;
                    $scope.cacheList();
                }
            });

            $scope.$watch('listParams.currentPage + listParams.numPerPage + sortBy + reverse', function (old, newie) {
                if (old != newie) {
                    $scope.cacheList();
                }
            });

            $scope.clear = function () {
                $scope.search = '';
                $scope.listParams.currentPage = 0;
                $scope.status = null;
                $scope.cacheList();
            }

            $scope.downloadVisit = function (visit) {
                visit.loading = true;
                visit.downloading = true;
                visit.resetting = false;
                visit.submitting = false;

                //if we have downloaded inspections pre cache the form edit pages on page load incase they downloaded them from a previous session.
                caches.keys().then(function (cachelist) {
                    cachelist.forEach(function (worker) {
                        caches.open(worker).then(function (cache) {
                            var url = paths.app + 'inspection/' + visit.service.id;
                            fetch(url).then(function (response) {
                                cache.put(url, response);
                            })
                            cache.add(paths.app + 'inspections/components/inspection/inspection.html');
                        });
                    });
                });

                $scope.cacheVisit(visit, true).then(function () {
                    IPCheckoutLogs.save({
                        id: visit.checkout_log_id != null ? visit.checkout_log_id : undefined,
                        visit_id: visit.id,
                        inspector_id: $rootScope.userAccount.inspector_id,
                        checked_out: true
                    }).then(function (checkoutLog) {
                        visit.checkout_log_id = checkoutLog.id;
                        setTimeout(function () {
                            visit.checked_out = true;
                            visit.loading = false;
                            visit.downloading = false;
                            $scope.$apply();
                        }, 5000);
                    });
                });
            }

            $scope.resetVisit = function (visit) {
                visit.loading = true;
                visit.resetting = true;
                visit.downloading = false;
                visit.submitting = false;

                $uibModal.open({
                    animation: true,
                    templateUrl: 'templates/confirm/confirm.html',
                    controller: 'ConfirmModalController',
                    resolve: {
                        message: function () {
                            return "This will reset your checklists to the most recently checked in checklist for each inspection.  You will lose any changes you have made since your last download.  Do you want to continue?";
                        }
                    }
                }).result.then(function (result) {
                    if (result) {
                        $scope.cacheVisit(visit, true).then(function () {
                            visit.loading = false;
                            visit.resetting = false;
                        });
                    }
                    else {
                        visit.loading = false;
                        visit.resetting = false;
                    }
                }, function () {
                    visit.loading = false;
                    visit.resetting = false;
                });
            }

            $scope.cacheVisit = function (visit, overwrite) {
                var d = $q.defer();

                $scope.cacheInspections(visit.inspections, overwrite).then(function (inspectionIDs) {
                    visit.checkedOutInspectionIDs = inspectionIDs;

                    var cachedVisit = angular.copy(visit);
                    cachedVisit.checked_out = true;
                    cachedVisit.loading = false;
                    cachedVisit.resetting = false;
                    cachedVisit.downloading = false;
                    cachedVisit.invalidInspections = [];
                    Cache.save('visit', cachedVisit).then(function () {
                        d.resolve();
                    });
                });

                return d.promise;
            }

            $scope.cacheInspections = function (visitInspections, overwrite) {
                var d = $q.defer();
                var promises = [];
                var inspectionIDs = [];

                $scope.prepareInspections(visitInspections, overwrite).then(function (inspections) {
                    inspections.forEach(function (inspection) {
                        inspectionIDs.push(inspection.id);
                        if (!inspection.cached) {
                            promises.push(Cache.save('inspection', inspection));
                            promises.push(TGTriggers.fire('Inspections.PerformingInspections.ChecklistsDownloaded', inspection.id));
                        }
                    });

                    $q.all(promises).then(function () {
                        d.resolve(inspectionIDs);
                    }).catch(function (response) {
                        // handle error
                    });  
                });

                return d.promise;
            }

            $scope.prepareInspections = function (visitInspections, overwrite) {
                var d = $q.defer();
                var promises = [];
                var inspections = [];

                visitInspections.forEach(function (visitInspection) {
                    visitInspection.inspectionNotCheckedOut = true;
                    if ((visitInspection.inspector_id == $rootScope.userAccount.inspector_id || visitInspection.inspector_id == null) &&
                        visitInspection.checklist != null && visitInspection.checklist.template != null &&
                        (visitInspection.status == null || visitInspection.status.allow_checkout)) {
                        promises.push($scope.prepareInspection(visitInspection, overwrite).then(function (inspection) {
                            if (inspection != null) {
                                visitInspection.inspectionNotCheckedOut = false;
                                inspections.push(inspection);
                            }
                        }));
                    }
                });

                $q.all(promises).then(function () {
                    d.resolve(inspections);
                }).catch(function (response) {
                    // handle error
                });  

                return d.promise;
            }

            $scope.prepareInspection = function (visitInspection, overwrite) {
                var d = $q.defer();

                if (!overwrite) {
                    Cache.get('inspection', visitInspection.id).then(function (inspection) {
                        if (inspection != null && inspection.checklist != null) {
                            visitInspection.cached = true;
                            visitInspection.checklist.deficiencies_fail_show = inspection.checklist.deficiencies_fail;
                            visitInspection.inspector_show = inspection.inspector == null ? null : inspection.inspector.name;
                            visitInspection.indicator = inspection.checklist.isFormValid == null ? { field: 'empty', title: 'Not Started' } : (inspection.checklist.isFormValid && $scope.deficenciesComplete(inspection.checklist)) ? { field: 'full', title: 'Complete' } : { field: 'half', title: 'Incomplete' };
                            visitInspection.inspector_show ? visitInspection.indicator.show = true : visitInspection.indicator.show = false;
                            if (visitInspection.indicator.show) visitInspection.checklist.document = null; // just to get rid of icon
                            d.resolve(visitInspection);
                        }
                        else {
                            $scope.prepareInspectionResponse(visitInspection).then(function (inspection) {
                                inspection.cached = false;
                                visitInspection.checklist.deficiencies_fail_show = inspection.checklist.deficiencies_fail;
                                visitInspection.inspector_show = inspection.inspector == null ? null : inspection.inspector.name;
                                visitInspection.indicator = inspection.checklist.isFormValid == null ? { field: 'empty', title: 'Not Started' } : (inspection.checklist.isFormValid && $scope.deficenciesComplete(inspection.checklist)) ? { field: 'full', title: 'Complete' } : { field: 'half', title: 'Incomplete' };
                                visitInspection.inspector_show ? visitInspection.indicator.show = true : visitInspection.indicator.show = false;
                                if (visitInspection.indicator.show) visitInspection.checklist.document = null; // just to get rid of icon
                                d.resolve(inspection);
                            });
                        }
                    });
                }
                else {
                    $scope.prepareInspectionResponse(visitInspection).then(function (inspection) {
                        inspection.cached = false;
                        visitInspection.checklist.deficiencies_fail_show = inspection.checklist.deficiencies_fail;
                        visitInspection.inspector_show = inspection.inspector == null ? null : inspection.inspector.name;
                        visitInspection.indicator = inspection.checklist.isFormValid == null ? { field: 'empty', title: 'Not Started' } : (inspection.checklist.isFormValid && $scope.deficenciesComplete(inspection.checklist)) ? { field: 'full', title: 'Complete' } : { field: 'half', title: 'Incomplete' };
                        visitInspection.inspector_show ? visitInspection.indicator.show = true : visitInspection.indicator.show = false;
                        if (visitInspection.indicator.show) visitInspection.checklist.document = null; // just to get rid of icon
                        d.resolve(inspection);
                    });
                }

                return d.promise;
            }

            $scope.deficenciesComplete = function (checklist) {
                return checklist.template.deficiencies_total == (checklist.deficiencies_fail + checklist.deficiencies_ignore + checklist.deficiencies_pass);
            }

            $scope.prepareInspectionResponse = function (visitInspection) {
                var d = $q.defer();

                if (visitInspection.checklist.response_id != null) {
                    FBResponses.getByID(visitInspection.checklist.response_id).then(function (response) {
                        var inspection = angular.copy(visitInspection);
                        inspection.checklist.response = response;
                        d.resolve(inspection);
                    });
                }
                else {
                    FBResponses.save({ Form_ID: visitInspection.checklist.template.form_id }, visitInspection.checklist.id).then(function (response) {
                        visitInspection.checklist.response_id = response.id;
                        var inspection = angular.copy(visitInspection);
                        inspection.checklist.response = response;
                        d.resolve(inspection);
                    });
                }

                return d.promise;
            }

            $scope.submitVisit = function (visit) {
                visit.loading = true;
                visit.resetting = false;
                visit.downloading = false;
                visit.submitting = true;
                visit.uploadStarted = false;
                visit.inspectionsCompleted = 1;
                visit.submissionChecklistCount = 0;
                $scope.submitting = true;

                $uibModal.open({
                    animation: true,
                    templateUrl: 'templates/confirm/confirm.html',
                    controller: 'ConfirmModalController',
                    resolve: {
                        message: function () {
                            return "You are about to upload all your inspection checklist data in this visit and will not be able to edit afterward. Do you want to continue?";
                        }
                    }
                }).result.then(function (result) {
                    if (result) {
                        Cache.get('visit', visit.id).then(function (cachedVisit) {
                            if (cachedVisit != null) {
                                $scope.handleOverride(cachedVisit).then(function (ignoreInspectionIDs) {
                                    if (ignoreInspectionIDs != null) {
                                        $scope.handleValidation(cachedVisit, ignoreInspectionIDs).then(function (invalidInspections) {
                                            if (invalidInspections != null) {
                                                invalidInspections.forEach(function (invalidInspection) {
                                                    cachedVisit.invalidInspections.push(invalidInspection.id);
                                                });
                                                $scope.handleSignature(cachedVisit, ignoreInspectionIDs).then(function (signed) {
                                                    if (signed != null) {
                                                        cachedVisit.signed = signed;
                                                        $scope.handleSubmit(cachedVisit, ignoreInspectionIDs, visit).then(function (success) {
                                                            // show success/fail message
                                                            visit.loading = false;
                                                            visit.submitting = false;
                                                            $scope.submitting = false;
                                                            visit.uploadStarted = false;
                                                            $scope.getVisits($scope.month, $scope.year);
                                                        });
                                                    }
                                                    else {
                                                        visit.loading = false;
                                                        visit.submitting = false;
                                                        $scope.submitting = false;
                                                        visit.uploadStarted = false;
                                                    }
                                                });
                                            }
                                            else {
                                                visit.loading = false;
                                                visit.submitting = false;
                                                $scope.submitting = false;
                                                visit.uploadStarted = false;
                                            }
                                        });
                                    }
                                    else {
                                        visit.loading = false;
                                        visit.submitting = false;
                                        $scope.submitting = false;
                                        visit.uploadStarted = false;
                                    }
                                });
                            }
                            else {
                                console.log('Visit is not cached');
                                visit.loading = false;
                                visit.submitting = false;
                                $scope.submitting = false;
                                visit.uploadStarted = false;
                            }
                        });
                    }
                    else {
                        visit.loading = false;
                        visit.submitting = false;
                        $scope.submitting = false;
                        visit.uploadStarted = false;
                    }
                }, function () {
                    visit.loading = false;
                    visit.submitting = false;
                    $scope.submitting = false;
                    visit.uploadStarted = false;
                });
            }

            $scope.handleSubmit = function (cachedVisit, ignoreInspectionIDs, visit) {
                var d = $q.defer();

                $scope.checkinVisit(cachedVisit, ignoreInspectionIDs, visit).then(function (success) {
                    if (success) {
                        IPCheckoutLogs.save({
                            id: visit.checkout_log_id != null ? visit.checkout_log_id : undefined,
                            visit_id: visit.id,
                            inspector_id: $rootScope.userAccount.inspector_id,
                            checked_out: false
                        }).then(function (checkoutLog) {
                            if (checkoutLog != null) {
                                visit.checkout_log_id = checkoutLog.id;
                                visit.checked_out = false;

                                var promises = [];

                                cachedVisit.checkedOutInspectionIDs.forEach(function (inspectionID) {
                                    promises.push(Cache.remove('inspection', inspectionID));
                                });

                                promises.push(Cache.remove('visit', cachedVisit.id));

                                $q.all(promises).then(function (arr) {
                                    d.resolve(true);
                                }).catch(function (response) {
                                    // handle error
                                });  
                            }
                            else {
                                console.log('visit unsucessfully checked in');
                                d.resolve(false);
                            }
                        }).catch(function (response) {
                            // handle error
                        });  
                    }
                    else {
                        console.log('visit unsucessfully submitted');
                        d.resolve(false);
                    }
                });

                return d.promise;
            }

            $scope.checkinVisit = function (cachedVisit, ignoreInspectionIDs, visit) {
                var d = $q.defer();
                var promises = [];
                var visitSuccessful = true;

                var allInspectionIDs = cachedVisit.checkedOutInspectionIDs.filter(function (inspectionID) {
                    return ignoreInspectionIDs.indexOf(inspectionID) == -1;
                });

                visit.submissionChecklistCount = allInspectionIDs.length;

                var chunkedInspectionIDs = chunkArray(allInspectionIDs, 2);
                chunkedInspectionIDs.sort(function (a, b) {
                    return a.length - b.length;
                });

                /*chunkedInspectionIDs.forEach(function (inspectionIDs) {
                    promises.push($scope.checkinInspections(inspectionIDs, cachedVisit).then(function (success) {
                        $scope.$evalAsync(function () {
                            visit.inspectionsCompleted += inspectionIDs.length;
                        });
                        visitSuccessful = visitSuccessful && success;
                    }));
                })
    
                $q.all(promises).then(function () {
                    d.resolve(visitSuccessful);
                });*/

                // This code is an alternative to the chunkedInspectionIDs.forEach bit - rather than firing off all inspections at the same time, it will process the chunks of inspections sequentially, waiting for each promise to complete before firing off the next one
                visit.uploadStarted = true;

                var promise = chunkedInspectionIDs.reduce(
                    function reducer(promiseChain, value) {
                        return promiseChain.then(function (result) {
                            return $scope.checkinInspections(value, cachedVisit).then(function (success) {
                                $scope.$evalAsync(function () {
                                    visit.inspectionsCompleted += value.length;
                                })
                                visitSuccessful = visitSuccessful && success;
                            });
                        })
                    },
                    promiseFunc()
                );

                promise.then(function () {
                    d.resolve(visitSuccessful);
                });

                return d.promise;
            }

            var promiseFunc = function () {
                var p = $q.defer();

                $scope.$evalAsync(function () {
                    p.resolve();
                });

                return p.promise;
            }

            $scope.checkinInspection = function (inspectionID, cachedVisit) {
                var d = $q.defer();

                Cache.get('inspection', inspectionID).then(function (cachedInspection) {
                    if (cachedInspection != null) {
                        if (cachedInspection.inspector_id == $rootScope.userAccount.inspector_id
                            && !(cachedInspection.checklist.template.require_signature && !cachedVisit.signed)
                            && (cachedVisit.invalidInspections.indexOf(inspectionID) == -1)) {
                            IPInspections.submit(cachedInspection, true).then(function (success) {
                                d.resolve(success);
                            });
                        }
                        else {
                            console.log('Ignore inspection');
                            d.resolve(true);
                        }
                    }
                    else {
                        console.log('Inspection not in cache');
                        d.resolve(true);
                    }
                });

                return d.promise;
            }

            $scope.checkinInspections = function (inspectionIDs, cachedVisit) {
                var d = $q.defer();;

                var promises = [];
                var cachedInspections = [];

                // get all of our inspections
                inspectionIDs.forEach(function (inspectionID) {
                    promises.push(Cache.get('inspection', inspectionID).then(function (cachedInspection) {
                        if (cachedInspection != null) {
                            if (cachedInspection.inspector_id == $rootScope.userAccount.inspector_id
                                && !(cachedInspection.checklist.template.require_signature && !cachedVisit.signed)
                                && !(cachedInspection.submitted !== undefined && cachedInspection.submitted == true)
                                && (cachedVisit.invalidInspections.indexOf(inspectionID) == -1)) {
                                cachedInspections.push(cachedInspection);
                            }
                            else {
                                console.log('Ignore inspection');
                            }
                        }
                        else {
                            console.log('Inspection not in cache');
                        }
                    }));
                });

                $q.all(promises).then(function (result) {
                    var cachedInspectionsCopy = angular.copy(cachedInspections);
                    IPInspections.submitBatch(cachedInspections, true).then(function (success) {
                        // update the cached inspection with a flag indicating it finished uploading
                        var updatePromises = [];
                        cachedInspections = null;
                        cachedInspectionsCopy.forEach(function (cachedInspection) {
                            if (cachedInspection != null) {
                                cachedInspection.submitted = true;
                                promises.push(Cache.save('inspection', cachedInspection));
                            }
                        });
                        $q.all(updatePromises).then(function (result) {
                            cachedInspectionsCopy = [];
                            d.resolve(success);
                        }).catch(function (response) {
                            // handle error
                        });  
                    });
                }).catch(function (response) {
                    // handle error
                });  

                return d.promise;
            }

            $scope.handleSignature = function (cachedVisit, ignoreInspectionIDs) {
                var d = $q.defer();

                $scope.getSignatureArray(cachedVisit, ignoreInspectionIDs).then(function (signatures) {
                    if (signatures != null && signatures.length > 0) {
                        $uibModal.open({
                            animation: true,
                            templateUrl: paths.app + 'inspections/components/signature-modal/signature-modal.html',
                            controller: 'PortalInspectionsSignatureModal',
                            resolve: {
                                inspections: function () {
                                    return signatures;
                                }
                            }
                        }).result.then(function (result) {
                            d.resolve(result);
                        }, function () {
                            d.resolve(null);
                        });
                    }
                    else {
                        d.resolve(true);
                    }
                });

                return d.promise;
            }

            $scope.getSignatureArray = function (cachedVisit, ignoreInspectionIDs) {
                var d = $q.defer();
                var promises = [];
                var signatures = [];

                cachedVisit.checkedOutInspectionIDs.forEach(function (inspectionID) {
                    if (ignoreInspectionIDs.indexOf(inspectionID) == -1) {
                        promises.push(Cache.get('inspection', inspectionID).then(function (cachedInspection) {
                            if (cachedInspection != null) {
                                if (cachedInspection.checklist.template.require_signature && cachedInspection.inspector_id == $rootScope.userAccount.inspector_id) {
                                    signatures.push(cachedInspection);
                                }
                            }
                            else {
                                console.log('Inspection not in cache');
                            }
                        }));
                    }
                });

                $q.all(promises).then(function () {
                    d.resolve(signatures);
                }).catch(function (response) {
                    // handle error
                });  

                return d.promise;
            }

            $scope.handleValidation = function (cachedVisit, ignoreInspectionIDs) {
                var d = $q.defer();

                $scope.validateVisit(cachedVisit, ignoreInspectionIDs).then(function (invalidInspections) {
                    if (invalidInspections != null && invalidInspections.length > 0) {
                        $uibModal.open({
                            animation: true,
                            templateUrl: paths.app + 'inspections/components/invalid-modal/invalid-modal.html',
                            controller: 'PortalInspectionsInvalidModal',
                            resolve: {
                                inspections: function () {
                                    return invalidInspections;
                                }
                            }
                        }).result.then(function (result) {
                            if (result == true) {
                                d.resolve(invalidInspections);
                            }
                            else {
                                d.resolve(null);
                            };
                        }, function () { d.resolve(null); });
                    }
                    else {
                        d.resolve(invalidInspections);
                    }
                });

                return d.promise;
            }

            $scope.validateVisit = function (cachedVisit, ignoreInspectionIDs) {
                var d = $q.defer();
                var promises = [];
                var invalidInspections = [];

                cachedVisit.checkedOutInspectionIDs.forEach(function (inspectionID) {
                    if (ignoreInspectionIDs.indexOf(inspectionID) == -1) {
                        promises.push(Cache.get('inspection', inspectionID).then(function (cachedInspection) {
                            if (cachedInspection != null) {
                                if (cachedInspection.inspector_id == $rootScope.userAccount.inspector_id) {
                                    if (!cachedInspection.checklist.isFormValid) {
                                        invalidInspections.push(cachedInspection);
                                    }
                                }
                            }
                            else {
                                console.log('Inspection not in cache');
                            }
                        }));
                    }
                });

                $q.all(promises).then(function () {
                    d.resolve(invalidInspections);
                }).catch(function (response) {
                    // handle error
                });  

                return d.promise;
            }

            $scope.handleOverride = function (cachedVisit) {
                var d = $q.defer();
                var ignoreInspectionIDs = [];

                $scope.getOverrideArray(cachedVisit).then(function (overrides) {
                    if (overrides != null && overrides.length > 0) {
                        $uibModal.open({
                            animation: true,
                            templateUrl: paths.app + 'inspections/components/override-modal/override-modal.html',
                            controller: 'PortalInspectionsOverrideModal',
                            resolve: {
                                inspections: function () {
                                    return overrides;
                                }
                            }
                        }).result.then(function (result) {
                            if (result) {
                                overrides.forEach(function (inspection) {
                                    ignoreInspectionIDs.push(inspection.id);
                                });

                                d.resolve(ignoreInspectionIDs);
                            }
                            else {
                                d.resolve(null);
                            }
                        }, function () {
                            d.resolve(null);
                        });
                    }
                    else {
                        d.resolve(ignoreInspectionIDs);
                    }
                });

                return d.promise;
            }

            $scope.getOverrideArray = function (cachedVisit) {
                var d = $q.defer();
                var promises = [];
                var overrides = [];

                cachedVisit.checkedOutInspectionIDs.forEach(function (inspectionID) {
                    promises.push($scope.checkOverride(inspectionID).then(function (inspection) {
                        if (inspection != null) {
                            overrides.push(inspection);
                        }
                    }));
                });

                $q.all(promises).then(function () {
                    d.resolve(overrides);
                }).catch(function (response) {
                    // handle error
                });  

                return d.promise;
            }

            $scope.checkOverride = function (inspectionID) {
                var d = $q.defer();

                Cache.get('inspection', inspectionID).then(function (cachedInspection) {
                    if (cachedInspection != null) {
                        if (cachedInspection.inspector_id == $rootScope.userAccount.inspector_id) {
                            IPInspections.getByID(inspectionID, true).then(function (inspection) {
                                if (inspection != null && inspection.inspector_id != $rootScope.userAccount.inspector_id && inspection.inspector_id != null && (inspection.submitted === undefined || inspection.submitted == true)) {
                                    d.resolve(inspection);
                                }
                                else {
                                    d.resolve(null);
                                }
                            });
                        }
                        else {
                            d.resolve(null);
                        }
                    }
                    else {
                        d.resolve(null);
                        console.log('Inspection not in cache');
                    }
                });

                return d.promise;
            }

            $window.onbeforeunload = function (e) {
                if ($scope.submitting) {
                    e.returnValue = "Please do not leave this page. If you do, you will lose your progress uploading your visit. Are you sure you want to leave?";
                    return "Please do not leave this page. If you do, you will lose your progress uploading your visit. Are you sure you want to leave?";
                }
            };
            $scope.$on('$stateChangeStart', function (event, next, current) {
                if ($scope.submitting) {
                    if (!confirm("Please do not leave this page. If you do, you will lose your progress uploading your visit. Are you sure you want to leave?")) {
                        event.preventDefault();
                    }
                }
            });
            $scope.$on('$destroy', function () {
                $window.onbeforeunload = undefined;
            });
        }]);